(function () {
	'use strict';

	angular
	.module('app.core')
		.directive('globalItemSearch', globalItemSearch);

	globalItemSearch.$inject = ['$rootScope'];
	function globalItemSearch($rootScope) {
		return {
			templateUrl: '/application/f/core/global-item-search/global-item-search.html',
			restrict: 'E',
			controller: 'globalItemSearchCtrl as globalItemSearchCtrl'
		};
	}
})();
